/** Naslov i opis ispod scene registracije. */
export const REGISTRATION_INTRO_TEXT = {
  title: "Vaša flota počinje ovdje",
  description: "Otvorite račun za tvrtku ili za sebe i odmah krenite s unosom vozila.",
};

/** Vrste korisnika kao na obrascu; prva je odabrana. */
export const REGISTRATION_INTRO_TENANT_TYPES = ["Tvrtka", "Osoba"];

/** Primjer podataka tvrtke na kartici računa. */
export const REGISTRATION_INTRO_COMPANY = {
  initials: "HR",
  name: "Horvat Rent d.o.o.",
  taxNumber: "12345678901",
  email: "info@horvatrent.hr",
};

/** Koraci početka rada na kartici prvog vozila. */
export const REGISTRATION_INTRO_STEPS = [
  { label: "Račun tvrtke", isDone: true },
  { label: "Prvo vozilo", isDone: true },
  { label: "Vozači", isDone: false },
];
